import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikGroup } from "src/types/networking/terminals/group.types";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";
import "./group-list.scss";
import { FileUploadedStatus } from "src/types";

export const useGroupList = ({ groupInfo }: { groupInfo: FormikGroup }) => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsiveBp();

  const { fixedList, collapsibleList } = useMemo(() => {
    const fixedItems = (!isDesktop ? 5 : 8) + 1;

    return {
      fixedList: groupInfo.group.slice(0, fixedItems),
      collapsibleList: groupInfo.group.slice(fixedItems),
    };
  }, [isDesktop, groupInfo.group]);

  const [visibileItems, setVisibleItems] = useState(fixedList.length);
  const [listIsExpanded, setListIsExpanded] = useState(false);

  useEffect(() => {
    if (!listIsExpanded) setVisibleItems(fixedList.length);
  }, [isDesktop]);

  function showModifyButton({
    errors,
  }: {
    errors: Record<string, string> | undefined;
  }): boolean {
    return (
      groupInfo.filesStatus != FileUploadedStatus.OK &&
      !!errors &&
      Object.keys(errors).length > 0
    );
  }

  return {
    fixedList,
    collapsibleList,
    visibileItems,
    listIsExpanded,
    t,
    setVisibleItems,
    setListIsExpanded,
    showModifyButton,
  };
};
